import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CustomPrintIcon = ({ color = '#8CA4C9', size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M3.33 0h13.333a.834.834 0 0 1 .837.831V14.17h1.599c.59 0 .899.377.899.892v4.108a.833.833 0 0 1-.83.831H.829A.832.832 0 0 1 0 19.169v-3.9c0-.472.182-1.1.984-1.1h1.512V.83A.834.834 0 0 1 3.329 0zm.832 1.669v12.5h11.671v-12.5H4.163zM1.667 15.835v2.496l16.663.001v-2.497H1.667zM5.829 4.423v-.001c0-.643.288-1.096.974-1.087h1.531c1.137-.025 1.137 1.692 0 1.667h-.836v1.667c0 1.112-1.669 1.112-1.669 0V4.423z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

CustomPrintIcon.propTypes = propTypes;

export default CustomPrintIcon;
